import { render } from "./App.vue?vue&type=template&id=542abbdd"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=542abbdd&lang=less"
script.render = render

export default script